import { createContext, useContext, useMemo, useState } from "react";
import axios from "axios";

const AuthContext = createContext(null);

// Cloudflare Pages + Functions aynı domainde:
const apiClient = axios.create({
  baseURL: "/api",
  headers: { "Content-Type": "application/json" },
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hrms_user") || "null");
    } catch {
      return null;
    }
  });

  // Bu projede JWT yok (şimdilik). O yüzden loading=false.
  const loading = false;

  const signup = async (formData) => {
    const res = await apiClient.post("/signup", {
      email: formData.email,
      username: formData.username,
      password: formData.password,
    });

    if (!res.data?.ok) throw new Error(res.data?.error || "Signup failed");

    // Signup sonrası otomatik giriş gibi davranalım:
    const newUser = { email: formData.email, username: formData.username };
    localStorage.setItem("hrms_user", JSON.stringify(newUser));
    setUser(newUser);

    return res.data;
  };

  const signin = async (credentials) => {
    // credentials: { identifier, password } (SignIn sayfası böyle gönderiyor)
    const res = await apiClient.post("/signin", credentials);

    if (!res.data?.ok) throw new Error(res.data?.error || "Signin failed");

    localStorage.setItem("hrms_user", JSON.stringify(res.data.user));
    setUser(res.data.user);

    return res.data;
  };

  const signout = () => {
    localStorage.removeItem("hrms_user");
    setUser(null);
  };

  const value = useMemo(
    () => ({
      user,
      loading,
      signup,
      signin,
      signout,
      isAuthenticated: !!user,
      api: apiClient, // Dashboard vs. bu client ile istek atıyor
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};
